export default {
    clientList: null
}